/**
 * Single source of truth for the sponsorship/ads card-processing fee, so the
 * cart, Stripe checkout, DB total, receipt email, and sponsor contract all show
 * the EXACT same number. A 3.5% fee on the subtotal (tier price + any video
 * upgrade), rounded to the nearest cent, itemized separately from the base so
 * the receipt's tax-substantiation stays clean.
 */
export const SERVICE_FEE_RATE = 0.035;
export const SERVICE_FEE_LABEL = 'Card processing fee (3.5%)';

/** The fee in cents for a given subtotal in cents. Rounded to the nearest cent. */
export function serviceFeeCents(subtotalCents: number): number {
  if (!Number.isFinite(subtotalCents) || subtotalCents <= 0) return 0;
  return Math.round(subtotalCents * SERVICE_FEE_RATE);
}

/** {subtotal, fee, total} in cents from a subtotal in cents. */
export function withServiceFee(subtotalCents: number): {
  subtotalCents: number;
  feeCents: number;
  totalCents: number;
} {
  const feeCents = serviceFeeCents(subtotalCents);
  return { subtotalCents, feeCents, totalCents: subtotalCents + feeCents };
}
